<div class="w-full flex flex-col items-center justify-center h-full bg-white">
  @if (!chartOptions() || loading) {
    <mat-spinner class="mt-8"></mat-spinner>
  } @else {
    @if (chartOptions()?.series.length === 0 || chartOptions()?.xaxis?.categories.length === 0) {
      <ts-empty-state
        icon="ts_close"
        class="py-8"
        title="No data available"
        subtitle="The selected fields returned no data for the period "
      ></ts-empty-state>
    } @else {
      <apx-chart
        class="w-full h-full"
        [series]="chartOptions()?.series"
        [chart]="chartOptions()?.chart"
        [xaxis]="chartOptions()?.xaxis"
        [yaxis]="chartOptions()?.yaxis"
        [tooltip]="chartOptions()?.tooltip"
        [dataLabels]="chartOptions()?.dataLabels"
        [plotOptions]="chartOptions()?.plotOptions"
      />
    }
  }
</div>
